import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { DatePipe } from '@angular/common';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { PasswordDialogComponent } from './lobby-dialogs/password-dialog/password-dialog.component';
import { LobbyContainerComponent } from './lobby-container/lobby-container.component';

import { PlayerRankLevelComponent } from './lobby-dialogs/player-rank-level/player-rank-level.component';
import { BonusUnlockComponent } from './lobby-dialogs/bonus-unlock/bonus-unlock.component';
import { SharedModule } from '../../shared/shared.module';
import { LobbyGameListComponent } from './lobby-game-list/lobby-game-list.component';
import { LobbyGameTableComponent } from './lobby-game-table/lobby-game-table.component';
import { LobbyListTablePreviewComponent } from './lobby-list-table-preview/lobby-list-table-preview.component';
import { LobbyListTableComponent } from './lobby-list-table/lobby-list-table.component';
import { LobbyChatComponent } from './lobby-chat/lobby-chat.component';
import { DialogLegendSymbol } from './lobby-dialogs/dialog-legend-symbol/dialog-legend-symbol.component';
import { LayoutModule } from '@angular/cdk/layout';
import { NavModule } from '../nav/nav.module';
import { TournamentModule } from '../tournament/tournament.module';
import { SwiperModule } from 'swiper/angular';
import { MatTooltipModule } from '@angular/material/tooltip';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { LobbyItemCardComponent } from './lobby-item-card/lobby-item-card.component';
import { LobbySubMenuComponent } from './lobby-sub-menu/lobby-sub-menu.component';
import { LobbyTitleComponent } from './lobby-title/lobby-title.component';
import { HelpDialogComponent } from './lobby-dialogs/bonus-unlock/dialogs/help-dialog/help-dialog.component';
import { ConfirmUnlockDialogComponent } from './lobby-dialogs/bonus-unlock/dialogs/confirm-unlock-dialog/confirm-unlock-dialog.component';
import { InsufficientDialogComponent } from './lobby-dialogs/bonus-unlock/dialogs/insufficient-dialog/insufficient-dialog.component';

@NgModule({
  imports: [
    CommonModule,
    SharedModule,
    FormsModule,
    ReactiveFormsModule,
    LayoutModule,
    NavModule,
    TournamentModule,
    SwiperModule,
    MatCheckboxModule,
    BrowserAnimationsModule,
    MatTooltipModule
  ],
  declarations: [
    LobbyContainerComponent,
    PasswordDialogComponent,
    PlayerRankLevelComponent,
    BonusUnlockComponent,
    LobbyGameListComponent,
    LobbyGameTableComponent,
    LobbyListTablePreviewComponent,
    LobbyListTableComponent,
    LobbyChatComponent,
    DialogLegendSymbol,
    LobbyItemCardComponent,
    LobbySubMenuComponent,
    LobbyTitleComponent,
    HelpDialogComponent,
    ConfirmUnlockDialogComponent,
    InsufficientDialogComponent,
  ],
  exports: [
    LobbyContainerComponent,
  ],
  providers: [
    DatePipe,
  ],
  entryComponents: [
    PasswordDialogComponent,
    PlayerRankLevelComponent,
    BonusUnlockComponent,
    DialogLegendSymbol
  ],
})

export class LobbyModule { }
